import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuyCoinService {

  constructor(private http : HttpClient) { }

  getBuyCurrencies(){
    return this.http.get(`${environment.apiUrl}/buycurrencies`)
  }

  getBuyFees(fiat_id, stable_id){
    return this.http.get(`${environment.apiUrl}/buyfees?buycurrency=${fiat_id}&source_currency=${stable_id}`)
  }

  getBuyRates(fiat_id, stable_id){
    return this.http.get(`${environment.apiUrl}/buyrates?buycurrency=${fiat_id}&source_currency=${stable_id}`)
  }

  getDestinationCurrencies(){
    return this.http.get(`${environment.apiUrl}/source-currencies`)
  }

  postBuyTransaction(transactionObject){
    return this.http.post(`${environment.apiUrl}/buytransactions`, transactionObject)
    // return this.http.get(`${environment.apiUrl}/buytransactions`)
  }

  postToPsi(psiObject){
    
    // &CustomerRefNo=${psiObject.CustomerRefNo}
// https://stagingcheckout.psigate.com/HTMLPost/HTMLMessenger?StoreKey=VVphwSUpVgkhfLGg2AU200017&SubTotal%3D101=&Email%3Dmustafa@alphafortress.com=&PaymentType%3DCC=&CardAction%3D0=&CustomerRefNo%3D9=

    // return this.http.post(`${environment.PSI_FORM_URL}?StoreKey=${psiObject.StoreKey}&SubTotal=${psiObject.SubTotal}&Email=${psiObject.Email}&PaymentType=${psiObject.PaymentType}&CardAction=${psiObject.CardAction}&CustomerRefNo=${psiObject.CustomerRefNo}`, psiObject)

    let body = `StoreKey=${psiObject.StoreKey}&SubTotal=${psiObject.SubTotal}&Email=${psiObject.Email}&PaymentType=${psiObject.PaymentType}&CardAction=${psiObject.CardAction}`

    return this.http.post(`${environment.PSI_FORM_URL}`, body)
  }
}
